module.exports = __webpack_public_path__ + "img/Mexico1.bd794e8a.png";